import { gql } from '@apollo/client';

export const GOALIE_STATS_FRAGMENT = gql`
  fragment GoalieStats on careerStatsGoalie {
    assists
    gamesPlayed
    goals
    goalsAgainst
    id
    loss
    otl
    pim
    shotsAgainst
    shutouts
    sol
    team
    tie
    win
  }
`;
